import React from 'react';

class JadwalUkt extends React.Component {
    render() {
        return (
            /* Tambahkan wrapper dengan inline style atau class baru */
            <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <table className="premium-table-modern" style={{ minWidth: '600px' }}>
                    <thead>
                        <tr>
                            <th width="40%">Kegiatan</th>
                            <th width="60%">Jadwal Mandiri di Kampus</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Pengisian Data UKT</td>
                            <td>15 - 18 Juli 2026</td>
                        </tr>
                        <tr>
                            <td>Pengumuman UKT</td>
                            <td>19 Juli 2026</td>
                        </tr>
                        <tr>
                            <td>Pembayaran UKT</td>
                            <td>19 Juli - 24 Juli 2026</td>
                        </tr>
                        <tr>
                            <td>Lapor Diri &amp; Registrasi</td>
                            <td>19 Juli - 25 Juli 2026</td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th width="40%">Kegiatan</th>
                            <th width="60%">Jadwal Mandiri Nilai UTBK</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Pengisian Data UKT</td>
                            <td>26 - 30 Juni 2026</td>
                        </tr>
                        <tr>
                            <td>Pengumuman UKT</td>
                            <td>2 Juli 2026</td>
                        </tr>
                        <tr>
                            <td>Pembayaran UKT</td>
                            <td>2 Juli - 10 Juli 2026</td>
                        </tr>
                        <tr>
                            <td>Lapor Diri &amp; Registrasi</td>
                            <td>2 Juli - 10 Juli 2026</td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th width="40%">Kegiatan</th>
                            <th width="60%">Jadwal Mandiri Rapor, Prestasi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Pengisian Data UKT</td>
                            <td>17 - 21 Juni 2026</td>
                        </tr>
                        <tr>
                            <td>Pengumuman UKT</td>
                            <td>23 Juni 2026</td>
                        </tr>
                        <tr>
                            <td>Pembayaran UKT</td>
                            <td>23 Juni - 22 Juli 2026</td>
                        </tr>
                        <tr>
                            <td>Lapor Diri &amp; Registrasi</td>
                            <td>23 Juni - 22 Juli 2026</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default JadwalUkt;